{
    "dashboard": {
        "addDashboard": "Add dashboard",
        "alreadyExists": "Dashboard with the name {dashboardName} already exists.",
        "confirmDeleteMessage": "Are you sure that you want to delete",
        "copyDashboard": "Copy Dashboard",
        "copyDashboardSuccess": "Dashboard copied successfully",
        "dashboard": "Dashboard",
        "dashboardDesc": "Dashboard description",
        "searchDashboards": "Search Dashboards",
        "dashboardId": {
            "noWidgetsInDashboard": "There are no widgets in this dashboard",
            "noWidgets": "There are no widgets in ",
            "noWidgetsAdded": "No widgets have been added yet.\nPlease click on a widget above and \ndrag and drop it to create new widgets.",
            "updateRoleSuccess": "Updated role successfully",
            "widget": {
                "addCondition": "Add condition",
                "barChart": "Bar",
                "chartType": "Chart type",
                "column": "Column",
                "copyToDashboard": "Copy to dashboard",
                "copyWidget": "Copy Widget",
                "copyWidgetSuccess": "Widget copied successfully",
                "count": "Count",
                "dataset": "Choose a dataset for the widget",
                "deleteCondition": "Delete condition",
                "deleteWidgetSuccess": "Widget deleted successfully",
                "display": "Display",
                "editWidget": "Edit widget",
                "exportScheduled": "Export scheduled. You will get notification when it is ready",
                "field": "Field",
                "goAheadAndSearchForRecordsIn": "Go ahead and search for records in",
                "infoBox": "Infobox",
                "itemColor": "Item color",
                "items": "Items",
                "label": "Label",
                "lineChart": "Line",
                "newWidget": "New widget",
                "noRecordsToDisplay": "No records to display.",
                "noDataAvailable": "No data available",
                "notLinked": "Not linked",
                "notPossibleToDownload": "Too much data for export",
                "noWidgets": "There is not widgets ",
                "number": "Number",
                "optionalDescription": "Optional description of the widget",
                "optionalDescriptionWidget": "Optional description of the widget",
                "show": "Show",
                "table": "Table",
                "tabMenu": {
                    "addField": "Add field name",
                    "activeWidget": "active widget",
                    "addRule": "Add Rule",
                    "addViewDetailsButton": "Add view Details button",
                    "advancedFilter": "Advanced filter",
                    "advancedCondition": "Advanced condition",
                    "advancedFilterInfoTooltip": "Detailed information about writing query",
                    "appName": "App name",
                    "appUrl": "App URL",
                    "advancedFilterQueryGuide": {
                        "and": "And",
                        "andDescription": "The AND operator displays a record if all the conditions separated by AND are true.",
                        "andExample": "ItemType:Ext AND Status:[10 TO 20]",
                        "between": "Between",
                        "betweenDescription": "In SQL, the BETWEEN operator is used to filter values within a range. Here you use square brackets [ ] for inclusive ranges.",
                        "betweenExample": "Status:[10 TO 20]",
                        "dateModifications": "Modifications based on date:",
                        "dateModificationsTitle": "1. Show data which has been modified in last 3 days",
                        "dateModificationsTitleEx": "__modified: [\"now-3d/d\" TO \"now/d\"]",
                        "dateModificationsTitle1": "2. Show rows, which had been created 2025-02-04",
                        "dateModificationsTitleEx1": "__created: \"2025-02-04\"",
                        "equalTo": "Equal to (=)",
                        "equalToDescription": "Retrieves records where the ItemNumber is 3000007.",
                        "equalToExample": "ItemNumber:3000007",
                        "example": "Example :",
                        "example1": "Example 1:",
                        "example2": "Example 2:",
                        "exists": "Exists",
                        "existsExample": "_ItemType:*",
                        "existsNotExists": "Exists / Not Exists",
                        "existsNotExistsDescription": "Here does not have a direct equivalent of EXISTS or NOT EXISTS, but you can use queries to check for the presence or absence of a field.",
                        "greaterThan": "Greater than (>)",
                        "greaterThanDescription": "Retrieves records where the Status is greater than 20.",
                        "greaterThanExample": "Status:>10",
                        "greaterThanOrEqualTo": "Greater than or equal to (>=)",
                        "greaterThanOrEqualToDescription": "Retrieves records where the Status is greater than or equal to 20.",
                        "greaterThanOrEqualToExample": "Status:>=10",
                        "in": "In",
                        "inDescription": "In SQL, the IN operator allows you to specify multiple values. Here you use a boolean OR.",
                        "inExample": "ItemNumber:(3000007 OR 3000047)",
                        "introductionDescription": "This document provides a guide to writing advanced filter queries using syntax in OpenSearch.",
                        "introductionTitle": "Introduction",
                        "lessThan": "Less than (<)",
                        "lessThanDescription": "Retrieves records where the Status is less than 20.",
                        "lessThanExample": "Status:<20",
                        "lessThanOrEqualTo": "Less than or equal to (<=)",
                        "lessThanOrEqualToDescription": "Retrieves records where the Status is less than or equal to 20.",
                        "lessThanOrEqualToExample": "Status:<=20",
                        "like": "Like",
                        "likeDescription": "In SQL, the LIKE operator is used for pattern matching. Here you use wildcard characters * and ?.",
                        "likeExample": "ItemNumber:300*",
                        "linkedSearchWidgetTitle": "Here is an example for a linked search widget",
                        "notEqualTo": "Not equal to (!=)",
                        "notEqualToDescription": "Retrieves records where the ItemNumber is not equal to 3000007.",
                        "notEqualToExample1": "!ItemNumber:3000007",
                        "notEqualToExample2": "!ItemNumber:3000007",
                        "notExists": "Not Exists",
                        "notExistsExample": "-_ItemType:*",
                        "operatorsTitle": "Operators:",
                        "or": "OR",
                        "orDescription": "The OR operator displays a record if any of the conditions separated by OR are true.",
                        "orExample": "ItemType:Ext OR (Status:[15 TO 25])",
                        "tagValue": "Example for Tag value",
                        "tagValueExample": "ItemType: {'{{'} tags.[ItemType] {'}}'}",
                        "tagValueExample1": "ProductGroup: {'{{'} tags.[Product Group] {'}}'}",
                        "where": "Where",
                        "whereDescription": "In SQL, the WHERE clause is used to filter records. Here you achieve this by specifying field names followed by a value to filter.",
                        "whereExample": "ItemNumber:3000007"
                    },
                    "appearance": "Appearance",
                    "backgroundColor": "Background color",
                    "boldText": "Bold text",
                    "charts": {
                        "barChart": "Bar chart",
                        "cakeChart": "Cake chart",
                        "lineChart": "Line chart"
                    },
                    "chooseDataset": "Choose dataset",
                    "chooseWorkflow": "Choose workflow",
                    "chooseEvent": "Choose event",
                    "customBackgroundColor": "Custom background color",
                    "data": "Data",
                    "dataFieldComparison": "Datafield comparison",
                    "dataWarningRules": "Data Warning Rules",
                    "defaultBackgroundColor": "Default background color",
                    "details": "Details",
                    "filter": "Filter",
                    "filtersHeader": "Filters",
                    "fonts": "Fonts",
                    "fontSize": "Font Size",
                    "fontSizeForTitle": "font size for title",
                    "foregroundColor": "Text color",
                    "from": "From",
                    "iconLeft": "Icon left",
                    "iconLeftSize": "Icon size left",
                    "iconPosition": "Icon Position",
                    "iconRight": "Icon right",
                    "iconRightSize": "Icon size Right",
                    "iconSize": "Size for Icon",
                    "linked": "linked",
                    "linkedWidgets": "Linked widgets",
                    "linkedWidgetsDescription": "Select widgets to be linked with input widget data",
                    "linkFrom": "Linked From",
                    "linkFromFieldCaption": "Select source widget to use as trigger for the current widget",
                    "mandatoryDatasetForWidget": "Mandatory dataset for widget",
                    "eventForWidget": "Event emitted by Linked from will be used as data source",
                    "mandatoryField": "Mandatory field",
                    "name": "Name",
                    "operators": {
                        "average": "Avg",
                        "max": "Max",
                        "min": "Min",
                        "sum": "Sum"
                    },
                    "optionalDescriptionOfTheDashboard": "Optional description of the dashboard",
                    "searchTableColumnsPlaceholder": "Search Table Columns",
                    "tableColumn": "Table Columns",
                    "select": "select",
                    "selectAll": "Select All",
                    "dragDropTableColumns": "Drag and drop to specify order for columns. At least one column must be selected.",
                    "selectDivider": "Select Divider",
                    "selectIcon": "Select Icon",
                    "selectIconSize": "Select icon size",
                    "selectLeftIcon": "Select left icon",
                    "selectLinkedWidgets": "Select linked widgets",
                    "selectRightIcon": "Select right icon",
                    "selectWidget": "Select widget",
                    "showFilters": "Show filters",
                    "showViewDetailsButton": "Show details Link",
                    "simpleFilter": "Simple filter",
                    "sqlBasedCodeQuery": "Query",
                    "closeSqlHelper": "Close query helper",
                    "showSqlHelper": "Show query helper",
                    "tagFieldComparison": "Tag comparison",
                    "text": "Text",
                    "to": "To",
                    "widgetData": "Widget Data",
                    "widgetDataset": "Widget dataset",
                    "widgetDescription": "Widget description",
                    "widgetName": "Widget name",
                    "workflows": "Workflows",
                    "connectedWorkflow": "Connected Workflow",
                    "workflowsInputSettings": "Workflow input settings",
                    "triggerExpression": "Trigger expression",
                    "triggerExpressionInfo": "JSONata expression determining the input to the workflow. Can include ",
                    "triggerExpressionInfo1": " for linked data\n",
                    "dataExpression": "Data expression",
                    "dataExpressionInfo": "Expression to extract data from the workflow response",
                    "descriptionExpression": "Description expression",
                    "descriptionExpressionInfo": "Expression to extract a description text from the workflow response",
                    "workflowResultSettings": "Workflow result settings",
                    "workflowResultSettingsInfo": "All settings below are ",
                    "workflowResultSettingsInfo1": " and takes either JSONpath or JSONdata expression",
                    "optional": "OPTIONAL",
                    "detailsDataExpression": "Details data expression",
                    "detailsDataExpressionInfo": "Expression to extract data from the workflow response, used when clicking ",
                    "detailsDataExpressionInfo1": " in certain widgets",
                    "viewDetails": "View details",
                    "detailsTextExpression": "Details text expression",
                    "detailsTextExpressionInfo": "Expression to extract text to be shown instead of ",
                    "detailsTextExpressionInfo1": " in certain widgets",
                    "detailsUrlExpression": "Details URL expression",
                    "detailsUrlExpressionInfo": "Expression to extract an URL to be used when clicking ",
                    "detailsUrlExpressionInfo1": " in certain widgets",
                    "schemaDefinitionExpression": "Schema definition expression",
                    "enableSelection": "Enable Selection",
                    "multipleRows": "Multiple Rows",
                    "singleRow": "Single Rows",
                    "editableTable": "Editable Table",
                    "selectEditableFields": "Select editable fields",
                    "typeEditableFields": "Type and press enter to add editable fields",
                    "useDropdown": "Use dropdown",
                    "selectDropdownColumn": "Select dropdown column",
                    "selectColumn": "Select column",
                    "dropdownColumnName": "Dropdown column name",
                    "enterColumnName": "Enter column name",
                    "addDropdownValue": "Add dropdown value",
                    "typeDropdownValues": "Type and press enter to add dropdown values",
                    "actions": "Actions",
                    "manageActions": "Manage Actions",
                    "actionSettings": "Action settings",
                    "listOfActions": "List of actions",
                    "addNewAction": "Add new action",
                    "noActionsYet": "No actions yet",
                    "actionName": "Action Name",
                    "actionDescription": "Action Description ",
                    "selectWorkflow": "Select Workflow",
                    "advancedWorkflowSettings": "Advanced Workflow Settings",
                    "triggerAction": "Trigger Action",
                    "triggerActionInfo": "JSONata expression determining the input to the workflow. Can include $selected for selected data , $linked for linked data",
                    "removeRowFromTable": "Remove Row from Table",
                    "removeOnSuccess": "Remove on success",
                    "removeOnFailure": "Remove on failure",
                    "verifyBeforeAction": "Verify before action",
                    "chooseChart": "Choose Chart Type",
                    "eventHandling": "Event Handling",
                    "showOnEvent": "Show on Event",
                    "hideOnEvent": "Hide on Event",
                    "showOnEventDescription": "Keeps the widget hidden until this event is triggered",
                    "hideOnEventDescription": "Hides the widget when this event is triggered",
                    "transform": "Transform",
                    "transformDescription": "Transform the input data before displaying it using JSONata. $linked is the path to the event data sent from Linked from source.",
                    "event": "Event",
                    "loadWidgetData": "Load widget data when dashboard is loaded",
                    "shouldNotLoad": "Should not initially load data for this widget",
                    "legacyDatasource": "If you change datasource in the new version, this change will be irreversible. The applied workflow will then only work in the new version and will no longer be compatible with the older version"
                },
                "iconSize": {
                    "extraSmall": "Extra Small",
                    "small": "Small",
                    "medium": "Medium",
                    "large": "Large"
                },
                "updatedSuccessfully": "Widget updated successfully",
                "viewDetails": "View details",
                "widgetDataset": "Widget dataset",
                "widgetCustomTable": "Widget custom table",
                "widgetDatasource": "Widget Datasource",
                "widgetChartType": "Chart Type",
                "widgetWorkflow": "Widget Workflow",
                "widgetDescription": "Widget Description",
                "widgetName": "Widget Name",
                "xAxis": "X-Axis",
                "yAxis": "Y-Axis",
                "last": "Last",
                "first": "First",
                "dataSource": {
                    "CUSTOM_TABLE": "Custom Table",
                    "EVENT": "Event",
                    "WORKFLOW": "Workflow"
                },
                "selectCustomTable": "Select Custom Table",
                "selectWorkflow": "Select Workflow",
                "selectEvent": "Select Event",
                "charts": {
                    "WIDGET_LINE_CHART": "Line Chart",
                    "WIDGET_BAR_CHART": "Bar Chart",
                    "WIDGET_PIE_CHART": "Pie Chart"
                },
                "linkedTo": "Linked to",
                "itemSelected": "{item} item selected",
                "itemsSelected": "{item} items selected",
                "selectAction": "Select action",
                "confirmExecute": "Are you sure that you want to execute \"{actionName}\" ?",
                "actionSuccessMsg": "{actionName} performed successfully on selected items.",
                "actionFailMsg": "{actionName} failed, please check workflow log.",
                "exportItem": "Export {count} item",
                "exportItems": "Export {count} items",
                "exportTooltipSingle": "Download {count} line to excel",
                "exportTooltipMultiple": "Download {count} lines to excel",
                "showAllItems": "Show all items",
                "failedToLoadTableData": "Failed to load table data",
                "failedToLoadDataForWidget": "Failed to load data for {widgetType} - {widgetName}",
                "failedToLoadInfoboxData": "Failed to load infobox data",
                "noRecordsFound": "No records found",
                "notPossibleToDwonload": "Not possible to download file.",
                "filterCompatibility": "If you modify these filters in the new version, this change will be irreversible. \nThe filters will then only work in the new version and will no longer be \ncompatible with the older version.",
                "noColumnsSelected": "No columns selected. Select at least 1 column to view the data.",
                "permissionError": "Unable to fetch data. Required permissions are missing",
                "tagPermissionError": "Unable to fetch data. A required tag is missing in tag comparison",
                "notPossibleToLoadData": "Not possible to load data"
            }
        },
        "dashboardName": "Dashboard name",
        "dashboardWidgets": "Dashboard widgets",
        "dataset": "Choose a dataset for the widget",
        "deleteConfirmation": "Delete Confirmation",
        "deleteDashboardSuccess": "Dashboard deleted successfully",
        "deleteWidgetSuccess": "Widget slettet suksessfult",
        "dragAndDropPreview": "Drag and drop the widget into the preview",
        "editDashboard": "Edit dashboard",
        "exitEditMode": "Exit edit mode",
        "loadMore": "Load more dashboards",
        "mandatoryField": "Mandatory field",
        "newDashboard": "New Dashboard",
        "noDashboardsOnSearch": "No dashboards found matching your search",
        "noRecords": "No records to show",
        "selectDashboard": "Select dashboard",
        "specialCharError": "Special characters: / $ *? {'{ }'} [] & % are not allowed",
        "title": "Dashboards",
        "widgetDataset": "Widget dataset",
        "widgetDescription": "Widget Description",
        "widgetPlaceholder": "Widget Placeholder",
        "widgetName": "Widget Name",
        "widgetNameCannotBeEmpty": "Widget name can not be empty.",
        "widgetPreview": "Widget Preview"
    },
    "menuItems": {
        "dashboard": "Dashboards"
    },
    "widget": {
        "addWidget": "Add Widget",
        "filters": {
            "convertedFilters": "Converted filter items",
            "convertedAdvanced": "Converted advanced filter",
            "editGroupName": {
                "title": "Edit filter group name",
                "label": "New name"
            },
            "header": "Filter",
            "and": "and",
            "rule": "Rule",
            "connectedWith": "(connected with {operator})",
            "newFilterName": "New filter",
            "newFilterDescription": "",
            "newGroup": "New Group",
            "addConditionsList": "Add conditions list",
            "addQuery": "Add manual query",
            "addFilterItem": "Add filter",
            "filterSummary": "FILTER SUMMARY",
            "selectFields": "Field",
            "selectCondition": "Condition",
            "valueType": "Value Type",
            "provided": "Value",
            "tag": "Tag",
            "field": "Field",
            "noConditions": "No conditions supported for selected field type",
            "startDate": "Start Date",
            "endDate": "End Date",
            "date": "Date",
            "range": "Range",
            "logical": {
                "and": "AND",
                "or": "OR"
            },
            "conditions": {
                "string": {
                    "EQUALS": "Equal To",
                    "GREATER_THAN": "After",
                    "GREATER_THAN_OR_EQUALS": "On or After",
                    "NOT_EQUALS": "Not Equal To",
                    "CONTAINS": "Contains",
                    "DOES_NOT_CONTAIN": "Does Not Contain",
                    "IS_BLANK": "Is empty",
                    "IS_NOT_BLANK": "Is not empty",
                    "LESS_THAN": "Before",
                    "LESS_THAN_OR_EQUALS": "On or Before"
                },
                "array": {
                    "CONTAINS": "Contains",
                    "DOES_NOT_CONTAIN": "Does Not Contain"
                },
                "number": {
                    "EQUALS": "Equal To",
                    "NOT_EQUALS": "Not Equal To",
                    "LESS_THAN": "Less Than",
                    "LESS_THAN_OR_EQUALS": "Less Than or Equal",
                    "GREATER_THAN": "Greater Than",
                    "GREATER_THAN_OR_EQUALS": "Greater Than or Equal"
                },
                "date": {
                    "EQUALS": "Is On",
                    "NOT_EQUALS": "Is Not On",
                    "CONTAINS": "Contains",
                    "DOES_NOT_CONTAIN": "Does Not Contain",
                    "IS_BLANK": "Is empty",
                    "IS_NOT_BLANK": "Is not empty",
                    "LESS_THAN": "Before",
                    "GREATER_THAN": "After",
                    "LESS_THAN_OR_EQUALS": "On Or Before",
                    "GREATER_THAN_OR_EQUALS": "On Or After"
                },
                "boolean": {
                    "EQUALS": "Is True",
                    "NOT_EQUALS": "Is False",
                    "CONTAINS": "Is True",
                    "NOT_CONTAINS": "Is False"
                }
            },
            "valueTypes": {
                "PROVIDED": "Manual",
                "TAG": "Tags",
                "FIELD": "Compare",
                "CONTEXT": "Context",
                "RELATIVE_DATE": "Relative date"
            }
        },
        "filterTab": {
            "addFilter": "Add Filter Rule",
            "editFilter": "Edit Filter",
            "deleteFilter": "Delete Filter",
            "appliedFilter": "Filtering is enabled",
            "legacyFilterInfo": "Filter from Vince Live v.1 is applied",
            "deleteFilterConfirmation": "Are you sure that you want to delete filter?",
            "filterDeleted": "Filter deleted successfully.",
            "noFilters": "No filters applied for this widget"
        },
        "connectedTo": "Connected to "
    },
    "widgetType": {
        "WIDGET_DISPLAY_BOX": {
            "label": "Display Widget"
        },
        "WIDGET_INFO_BOX": {
            "label": "Info Widget"
        },
        "WIDGET_LINE_CHART": {
            "label": "Chart Widget"
        },
        "WIDGET_SEARCH_BOX": {
            "label": "Input Widget"
        },
        "WIDGET_TABLE": {
            "label": "Table Widget"
        },
        "WIDGET_MAP": {
            "label": "Map Widget"
        },
        "WIDGET_WORKFLOW": {
            "label": "Workflow Widget"
        }
    }
}
